export const coachesDefault = [
  'https://res.cloudinary.com/dgerdfai4/image/upload/w_360,h_360,g_face,c_thumb,r_180/v1685119865/teacher/photos/vys4odr89j9xecisy44o.jpg',
  'https://res.cloudinary.com/dgerdfai4/image/upload/w_360,h_360,g_face,c_thumb,r_180/v1672560332/teacher/photos/cvbd5ptidbdqegdv0atm.jpg',
  'https://res.cloudinary.com/dgerdfai4/image/upload/w_360,h_360,g_face,c_thumb,r_180/v1724433802/teacher/photos/wrads4yxyralc5es0cgl.jpg',
  'https://res.cloudinary.com/dgerdfai4/image/upload/w_360,h_360,g_face,c_thumb,r_180/v1658808179/teacher/photos/zmo1kkpgrjdsnxdilnvw.jpg'
];

export const defaultAvatar =
  'https://res.cloudinary.com/dgerdfai4/image/upload/w_100,h_100,c_thumb,r_50/v1587531490/ic_default_profile.jpg';
